import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';
import { LookUpService } from 'src/app/services/lookup.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
    currentDateStr: string = new Date().getFullYear().toString();

    youtube: string | undefined;
    twitter: string | undefined;
    linkedin: string | undefined;
    instagram: string | undefined;
    faceBook: string | undefined;
    email: string | undefined;
    adress: string | undefined;
    phone: string | undefined;
    logoFooter: string | undefined;
    location: string | undefined;
    locationMap: string | undefined;
    constructor(
        private lookUpService: LookUpService,
        public router: Router
    ) { }
    aboutUsPages: AboutUsPages | undefined;

    ngOnInit(): void {

        this.lookUpService.getAll$().subscribe(x => {
            this.twitter = x.find(x => x?.name == "Twitter")?.value;
            this.instagram = x.find(x => x?.name == "Instagram")?.value;
            this.faceBook = x.find(x => x?.name == "FaceBook")?.value;
            this.linkedin = x.find(x => x?.name == "Linkedin")?.value;
            this.youtube = x.find(x => x?.name == "Youtube")?.value;
            this.email = x.find(x => x?.name == "Email")?.value;
            this.phone = x.find(x => x?.name == "Phone")?.value;
            this.logoFooter = x.find(x => x?.name == "LogoFooter")?.value;
            this.locationMap = x.find(x => x?.name == "LocationMap")?.value;
            this.location = x.find(x => x?.name == "Location")?.value;
        });
    }
    openSocalMediaNewWindow(id: string | undefined) {
        this.lookUpService.openSocalMediaNewWindow(id);
    }
    createImgPath = (serverPath: string) => {
        return this.lookUpService.createImgPath(serverPath);
    }
}